import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=79a9acac&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=79a9acac&prod&lang=less&scoped=true"
import style1 from "./goods.vue?vue&type=style&index=1&id=79a9acac&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9acac",
  null
  
)

export default component.exports